import { ConfigurationState } from '@app/store/configuration'
import { getAppUrl } from '@app/utils'

import { getBacktrack } from './getBacktrack'

const getNormalizedBaseUrl = (baseUrl: string): string => {
  const candidate = baseUrl?.trim()

  if (candidate) {
    try {
      return new URL(candidate).href
    } catch {
      if (typeof window !== 'undefined' && window.location?.origin) {
        try {
          return new URL(candidate, window.location.origin).href
        } catch {
          return window.location.origin
        }
      }
    }
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }

  return '/'
}

const ensureFullUrl = (url: string, baseUrl: string): string => {
  const normalizedBaseUrl = getNormalizedBaseUrl(baseUrl)
  const value = (url || '').trim()

  if (!value) {
    return normalizedBaseUrl
  }

  try {
    return new URL(value).href
  } catch {
    try {
      return new URL(value, normalizedBaseUrl).href
    } catch {
      return normalizedBaseUrl
    }
  }
}

export const getBackUrl = (configuration: ConfigurationState): string => {
  const referrer = getBacktrack()
  const baseUrl = getAppUrl(configuration, '')
  return ensureFullUrl(referrer || '', baseUrl)
}
